import { Component, Input} from '@angular/core';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { TokenSerie } from 'src/app/assabil-kernel/models/entities/control-tables/token-serie';
import { MatDialogRef } from '@angular/material/dialog';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';


@Component({
    selector: 'token-serie-lov',
    templateUrl: './token-serie-lov.component.html',
    styleUrls: ['./token-serie-lov.component.scss']
})


export class TokenSerieLovComponent extends GenericLovComponent {

    @Input() code         : string; 
    @Input() name         : string; 

    tokenSeries           : TokenSerie[] = [];

    columns = [
        {  prop: 'tokenSerieCode',  name: 'Code'},
        {  prop: 'name',             name: 'Nom'},
    ]


//----------------------------------------------------------------------
constructor(
    public dialogRef: MatDialogRef<TokenSerieLovComponent>,
        protected controlTablesService  : ControlTablesService) {
            super();

            this.entityName = "tokenSerie";
    }
//----------------------------------------------------------------------
    


//----------------------------------------------------------------------
    loadData() {
        let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
        request.strArg1 = this.code;
        request.strArg2 = this.name;

        this.controlTablesService.getList(this.entityName, request).then(result => {
            this.tokenSeries = result;
        })
    }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
closeModal(row : TokenSerie){
    this.dialogRef.close(row);
}
//----------------------------------------------------------------------


}
